import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type TextToSpeechWidgetStore } from 'widgets/TextToSpeech'
import styles from './styles.module.scss'

export const TextToSpeechModalActions = observer(
  ({ store, onClose }: { store: TextToSpeechWidgetStore; onClose: () => void }) => {
    const isAutoName = store.createTextToSpeechStoreProps?.autoName
    const submitText = isAutoName ? 'Create' : 'Next'

    const handleSubmit = () => {
      if (isAutoName) {
        store.onCreate()
      } else {
        onClose()
        store.onCreate()
      }
    }

    return (
      <>
        <Button
          className={styles.button}
          text={'Cancel'}
          contained={'secondary'}
          size={'medium'}
          onClick={onClose}
          disabled={store.isCreating}
        />
        <Button
          className={styles.button}
          text={submitText}
          contained={'primary'}
          size={'medium'}
          disabled={store.isEmpty || store.isDisabledCreate || store.isCreating}
          loading={store.isCreating}
          onClick={handleSubmit}
        />
      </>
    )
  }
)
